import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

//import { Link } from 'react-router-dom';
import { withAppContext } from '../contexts/app';

import ArrowIcon from 'images/ask/icons/arrow-01.svg';
import HandPhone02 from 'images/ask/hand-phone-02.svg';

import ImageUploader from '../components/ImageUploader';

import LadyCityPadImage from 'images/ask/lady-city-pad.svg';

/* import ContactUs from '../components/cta/ContactUs'; */
import CTAGetStarted from '../components/cta/GetStarted';
//import TestedBy from '../components/sections/TestedBy';
import SupportedConditions from '../components/sections/SupportedConditions';
import InfoBox from './about/InfoBox';
import Testimonials from './about/Testimonials';
//import SelectedResearch from './about/SelectedResearch';

const statisticsData = [
  {
    value: '1 in 4',
    indicator: 'Americans visit a doctor',
    info: 'for a skin problem every year'
  },
  {
    value: '80%',
    indicator: 'Begin their health journey',
    info: 'with a web search'
  },
  {
    value: '98%',
    indicator: 'Survival rate',
    info: 'of skin cancer if detected early'
  },
  {
    value: '1,000+',
    indicator: 'Conditions and symptoms',
    info: 'supported by Triage’s skin checker'
  },
];
const conditions = [
  'Acne',
  'Cold sores',
  'Rashes',
  'STIs',
  'Warts',
  'Moles',
  'Sun damage',
  'Eczema',
  'Psoriasis',
  'Rosacea'
];

class About extends PureComponent {
  render() {
    return (
      <div className="about-view">
        <section className="hero">
          <div className="container">
            <h1>Detect disease in a snap.</h1>
            <p>
              We know the complexities of dermatology can be daunting, so we’ve developed a tool to provide you with an instant second opinion.
              You can compare your differential to our expert AI. Triage gives you a list of possible conditions from your photo and helps you think of things you might have missed.
            </p>
          </div>
        </section>

        {/*<TestedBy title="Tested by major hospitals and medical schools" />*/}

        <div className="container">
          <span className="about__separator" />
        </div>

        <section className="helping-finding-answers">
          <div className="container">
            <div className="helping-finding-answers__header">
              <h1>
                Developed by dermatologists, powered by AI.
              </h1>
            </div>
            <div className="helping-finding-answers__content">
              <div className="skin-search">
                <h3>Clinical skin search</h3>
                <p>
                  We have developed a clinical platform to empower all types of clinicians with accurate dermatology education.
                  With just the snap of a photo, either from your smartphone or tablet or through a dermatoscope, you can screen your patients for concerns and get a second opinion instantly.
                </p>
                <span className="link-with-icon">
                  <ImageUploader
                    className="start-your-scan-link"
                    label="Start skin scan"
                    onUpload={this.onImageUpload.bind(this)}
                  />
                  <img src={ArrowIcon} />
                </span>
                <div className="progress"></div>
              </div>
              <div className="skin-search">
                <h3>Patient skin search</h3>
                <p>
                  When you have problems with your skin, searching symptoms online can be frustrating and overwhelming.
                  Triage is a platform developed to help you get answers easier.
                  By using artificial intelligence, we have developed technology capable of accurately analyzing your skin.
                  We provide you with a list of possible conditions to empower you to figure out what to do next.
                </p>
                <span className="link-with-icon">
                  <ImageUploader
                    className="start-your-scan-link"
                    label="Start skin scan"
                    onUpload={this.onImageUpload.bind(this)}
                  />
                  <img src={ArrowIcon} />
                </span>
                <div className="progress"></div>
              </div>
            </div>
          </div>
        </section>

        <section className="statistics">
          <div className="container">
            {
              statisticsData.map(info => <InfoBox key={info.indicator} {...info} />)
            }
          </div>
        </section>

        <section className="our-mission">
          <div className="container">
            <h2>Our mission</h2>
            <p>Triage’s mission is to deliver universal care using artificial intelligence.</p>
            <img src={HandPhone02} />
          </div>
        </section>

        <section className="our-story">
          <div className="container">
            <div className="our-story__content">
              <h2>Our story</h2>
              <p>
                Triage is an international group of doctors and scientists on a mission to deliver universal care using artificial intelligence.
                With the support of world-renowned institutions, Triage has developed breakthrough technology which can detect skin disease using a smartphone.
              </p>
            </div>
          </div>
        </section>

        <img src={LadyCityPadImage} className="lady-city-pad-image" />

        <SupportedConditions
          conditions={conditions}
          title="Triage supports these common conditions and hundreds more"
        />
        <Testimonials />
        {/*<SelectedResearch />*/}
        {/*<ContactUs />*/}
        <CTAGetStarted />
      </div>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }
}

About.defaultProps = {};

About.propTypes = {
  app: PropTypes.object.isRequired
};

export { About };
export default withAppContext(About);
